export default __webpack_public_path__ + "static/Gilroy-Light-cc7ab55d27205bd640016b19810e50c7.otf";